<template>
  <section>
    <div class="main-wrapper">
      <div class="logo" @click="pushToDashboard">
        <img :src="require('@/assets/logo.svg')" @click="pushToDashboard" />
      </div>
      <div class="centre-wrap">
        <div class="close" @click="close">
          <img src="@/assets/ico/close_48px.svg" />
        </div>
        <div class="tittle-upgrade">
          <h1>{{ $t('upgradeYourTeam') }}</h1>
          <h5>{{ $t('giveYourTeamAFlexibility') }}</h5>
          <div class="annual-toggle-monthly">
            <div class="monthly" :class="{ 'fade-away': !isMonthly }" @click="triggerSwitch">
              {{ $t('monthly') }}
            </div>
            <regular-toggle class="toggle" reference="toggle" :toggle-triggered="!isMonthly" :initial-value="!isMonthly" @toggle="targetDateToggle" />

            <div class="annual" :class="{ 'fade-away': isMonthly }" @click="triggerSwitch">
              {{ $t('annual') }}
            </div>
            <div class="save-section">
              <img :src="require('@/assets/ico/save-arrow.svg')" />
              <div class="save-text">
                {{ $t('saveAmount', { amount: yearlySavePercentage }) }}
              </div>
            </div>
          </div>
        </div>
        <div class="main-column">
          <PlanComponent
            :price-per-member="pricePerMemberFree"
            :is-free="true"
            class="plan-items"
            :type-of-plan="$t('free')"
            :is-monthly="isMonthly"
            :content-of-the-plan="contentTextFree"
          />
          <PlanComponent
            :price-per-member="pricePermemberNoTaxFormatted"
            :is-free="false"
            class="plan-items"
            :is-monthly="isMonthly"
            :type-of-plan="$t('standard')"
            :content-of-the-plan="contentTextStandard"
            @button-clicked="upgradePlanClicked"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ParseFunctions from '@/components/ParseFunctions'
import EventBus from '@/EventBus'
import Constants from '@/components/Constants'
import Payment from '@/components/Billing/Payment'
import RegularToggle from '@/components/UI/RegularToggle'
import PlanComponent from '@/components/Billing/PlanComponent'
import { isString } from '@sentry/utils'

export default {
  name: 'UpgradePlan',
  components: {
    PlanComponent,
    RegularToggle,
  },
  mixins: [ParseFunctions, Constants],
  data() {
    return {
      subtotal: '-',
      tax: '-',
      pricePerPersonPerMonth: '-',
      pricePerMemberFree: '',
      activeUsers: '-',
      duration: '-',
      total: '-',
      countryCode: '',
      country: '',
      teamId: '-',
      currency: undefined,
      businessPurchase: false,
      plan: 'standardYearly',
      isMonthly: false,
      pricePermemberNoTaxFormatted: '-',
      yearlySavePercentage: 0,
      contentTextFree: [
        this.$t('flexibleworktimeshceduling'),
        this.$t('smartremindersandnotifications'),
        this.$t('timeoffmanagement'),
        this.$t('multipletimezonessupport'),
        this.$t('multipleworkplaces'),
        this.$t('homeofficeandremoteworkmanagement'),
        this.$t('leavedaystracking'),
      ],
      contentTextStandard: [
        this.$t('flexibleworktimeshceduling'),
        this.$t('smartremindersandnotifications'),
        this.$t('timeoffmanagement'),
        this.$t('multipletimezonessupport'),
        this.$t('multipleworkplaces'),
        this.$t('homeofficeandremoteworkmanagement'),
        this.$t('leavedaystracking'),
        this.$t('unlimitedteammembers'),
        this.$t('multipleteams'),
        this.$t('unlimitedmanagers'),
        this.$t('calendarintegration'),
        this.$t('systemStatusIntegration', { system: 'Slack' }),
      ],
      isBillingInfo: false,
      cardLast4: '',
    }
  },
  async mounted() {},
  async created() {
    try {
      this.teamId = this.$route.query['teamId']
      this.currency = this.$route.query['currency']
      this.isBillingInfo = this.$route.query['isBillingInfo']
      if (isString(this.isBillingInfo)) {
        this.isBillingInfo = this.isBillingInfo === 'true' ? true : false
      }
      if (this.isBillingInfo) {
        this.countryCode = this.$route.query['country']
        this.cardLast4 = this.$route.query['cardLast4']
        // console.log(this.isBillingInfo)
      } else {
        let moment = require('moment-timezone')
        let userTimezone = moment.tz.guess()
        this.countryCode = this.$store.state.timezonesGlobal.find((x) => x.value === userTimezone).countryCode
      }
    } catch (e) {
      console.error('mounting stripe elements error', e)
    }

    await this.updateSubscriptionPriceDetails()
    // console.log('getPriceOfOneUnitNoTax args:', this.countryCode, this.plan, navigator.language)
    // console.log('getPriceOfOneUnitNoTax res:', await this.getPriceOfOneUnitNoTax(this.countryCode, this.plan, navigator.language))
  },
  methods: {
    async pushToDashboard() {
      await this.$router.push({
        path: '/',
        name: 'Dashboard',
        query: {
          teamId: this.teamId,
        },
      })
    },
    async close() {
      await this.$router.push({
        path: '/',
        query: { teamId: this.teamId, tabName: 'TeamBilling' },
        hash: 'AdminSettings',
      })
    },
    async upgradePlanClicked() {
      await this.$router.push({
        path: '/payment',
        name: 'Payment',
        component: Payment,
        query: {
          teamId: this.teamId,
          isBillingInfo: this.isBillingInfo,
          country: this.countryCode,
          cardLast4: this.cardLast4,
          isMonthly: this.isMonthly.toString(),
        },
        hash: '',
      })
    },

    async updateSubscriptionPriceDetails() {
      let res = await this.getPriceOfOneUnitNoTax(this.countryCode, this.plan, this.$i18n.locale, this.currency)
      // console.log('getPriceOfOneUnitNoTax', res)

      if (res.status === 'ok') {
        this.pricePerMemberFree = res.pricePerMemberFreeFormatted
        this.pricePermemberNoTaxFormatted = res.pricePerMemberMonthlyNoTaxFormatted
        this.yearlySavePercentage = res.yearlySavePercentage
      }
    },
    triggerSwitch() {
      EventBus.$emit('triggerToggle')
    },
    async targetDateToggle() {
      this.isMonthly = !this.isMonthly
      this.plan = this.isMonthly ? 'standardMonthly' : 'standardYearly'
      await this.updateSubscriptionPriceDetails()
    },
  },
}
</script>

<style lang="scss" scoped>
h6 {
  @include font-rule('averta-bold');
  font-size: 20px;
}
h1 {
  margin-top: 84px;
  text-align: center;
  @include font-rule('averta-bold');
  font-size: 48px;
  line-height: 54px;
  margin-bottom: 0px;
  color: $black;

  @include respond-below(xs) {
    font-size: 36px;
    line-height: 48px;
  }
}
h5 {
  margin-top: 18px;
  @include font-rule('averta-regular');
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 54px;
  text-align: center;
}

.main-wrapper {
  div.logo {
    position: absolute;
    top: 20px;
    left: 20px;
    cursor: pointer;
    img {
      width: 120px;
    }
  }

  div.close {
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
    &:hover {
      opacity: 0.5;
    }
  }

  .annual-toggle-monthly {
    margin-bottom: 48px;
    * {
      margin-right: 8px;
      margin-left: 8px;
      transition: 0.2s ease;
      @include font-rule('averta-semibold');
    }
    display: flex;
    position: relative;
    flex-direction: row;
    justify-content: center;
    @include font-rule('averta-semibold');
    grid-template-areas: 'annual toggle monthly';

    .monthly,
    .annual {
      line-height: 28px;
      cursor: pointer;
    }
    .fade-away {
      opacity: 0.5;
      transition: 0.2s ease;
    }
    .save-section {
      right: -66px;
      top: -24px;
      position: absolute;
      .save-text {
        top: -15px;
        white-space: nowrap;
        position: absolute;
        transform: rotate(8deg);
        color: #10cf84;
        font-family: 'gochihand-regular';
        font-size: 24px;
      }
      @include respond-below(xs) {
        right: -60px;
        .save-text {
          left: -70px;
          top: -16px;
          transform: rotate(6deg);
        }
        img {
          transform: rotate(-20deg);
        }
      }
    }
  }

  .centre-wrap {
    display: flex;
    align-content: center;
    flex-direction: column;
    align-items: center;
    padding-bottom: 120px;

    .tittle-upgrade {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      margin: 0 20px;
    }
    .main-column {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap-reverse;
      justify-content: center;

      .plan-items {
        margin-left: 20px;
        margin-right: 20px;
        margin-bottom: 48px;
      }
    }
  }
}
</style>
